import request from '@/utils/request'

export function getList(data) {
    return request({
        url: '/backend/tool/miniprogram/getList',
        method: 'post',
        data: data
    })
}
export function createUpdate(data) {
    return request({
        url: '/backend/tool/miniprogram/createUpdate',
        method: 'post',
        data: data
    })
}

export function del(data) {
    return request({
        url: '/backend/tool/miniprogram/delete',
        method: 'post',
        data: data
    })
}
export function updateStatus(data) {
    return request({
        url: '/backend/tool/miniprogram/updateStatus',
        method: 'post',
        data: data
    })
}